var ThresholdPlot, ThresholdPlotView, View,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

ThresholdPlot = require('components/evidence_syntheses/threshold_plot');

View = require('base/views/view');

module.exports = ThresholdPlotView = (function(_super) {
  __extends(ThresholdPlotView, _super);

  function ThresholdPlotView() {
    return ThresholdPlotView.__super__.constructor.apply(this, arguments);
  }

  ThresholdPlotView.prototype.autoRender = false;

  ThresholdPlotView.prototype.className = 'outcomes threshold-plot-view';

  ThresholdPlotView.prototype.render = function() {
    ThresholdPlotView.__super__.render.apply(this, arguments);
    this.$el.html("<div class=\"threshold-plot-view__toolbar\">\n  <button class=\"table-mode\"></button>\n</div>\n<div class=\"threshold-plot-view__content\"></div>");
    if (typeof this.options.showTableViewsMenu === 'function') {
      this.delegate('click', 'button.table-mode', this.options.showTableViewsMenu);
    }
    ReactDOM.render(React.createElement(ThresholdPlot, {
      sourceType: 'regular',
      qId: this.options.questionModel.get('_id'),
      plotMode: 'comparisonAcrossOutcomes'
    }), this.$('.threshold-plot-view__content')[0]);
    return this;
  };

  ThresholdPlotView.prototype.dispose = function() {
    if (this.$el != null) {
      ReactDOM.unmountComponentAtNode(this.$('.threshold-plot-view__content')[0]);
    }
    return ThresholdPlotView.__super__.dispose.apply(this, arguments);
  };

  return ThresholdPlotView;

})(View);
